import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../modules/authentication/auth.service';

@Component({
    selector: 'app-microsoft-legacy',
    templateUrl: './microsoft-legacy.component.html',
    styleUrls: ['./microsoft-legacy.component.scss']
})
export class MicrosoftLegacyComponent implements OnInit {
    public isAuthenticating = false;

    constructor(private authService: AuthService) {
        this.isAuthenticating = authService.isAuthenticating;
    }

    ngOnInit(): void {}

    public handleAuthenticateExchangeOnline(event: { email: string; password?: string }) {
        this.authService.authenicateMicrosoftUser('exchange-online', event);
    }

    public handleAuthenticateExchange(event: { email: string; password?: string }) {
        this.authService.authenicateMicrosoftUser('exchange-legacy', event);
    }
}
